// 관제 채팅 멤버 목록에 "이번 차수에 쓴 타수 / 3"을 붙이기 위한 집계.
// 기준은 레이드 현황과 같다 - 실전 기록 한 줄이 한 타다(raidOverviewEngine의 attackCount와 동일).
// 명단(멤버)과 실전 기록의 openid 표기가 다를 수 있어 숫자만 남긴 키와 닉네임으로 함께 맞춘다.

export const RAID_CONTROL_ATTACK_LIMIT = 3;

const text = (value) => String(value ?? '').trim();

function decodeMaybeBase64(value) {
  if (!/^[A-Za-z0-9+/=]{8,}$/.test(value)) return '';
  try {
    if (typeof atob === 'function') return atob(value);
  } catch {
    return '';
  }
  return '';
}

// raidOverviewEngine의 normalizedOpenid와 같은 규칙을 쓴다 - 현황 기록이 그 규칙으로 정규화되어 온다.
export function normalizeAttackOpenid(value) {
  const raw = text(value);
  if (!raw) return '';
  for (const candidate of [raw, decodeMaybeBase64(raw)]) {
    if (!candidate) continue;
    const hyphen = candidate.match(/^\d+-([0-9]{8,})$/);
    if (hyphen) return hyphen[1];
    if (/^[0-9]{8,}$/.test(candidate)) return candidate;
    const groups = candidate.match(/[0-9]{8,}/g);
    if (groups?.length) return groups.at(-1);
  }
  return raw;
}

function normalizeNickname(value) {
  return text(value).toLocaleLowerCase('ko-KR').replace(/\s+/g, '');
}

// 멤버별 사용 타수를 Map<memberOpenid, number>로 돌려준다. 명단에 없는 기록은 버린다.
export function buildRaidControlAttackCountByMember({ members = [], records = [], limit = RAID_CONTROL_ATTACK_LIMIT } = {}) {
  const maxCount = Math.max(0, Number(limit) || 0);
  const roster = Array.isArray(members) ? members : [];
  const openidToMember = new Map();
  const nicknameToMember = new Map();
  const counts = new Map();

  for (const member of roster) {
    const memberOpenid = text(member?.memberOpenid);
    if (!memberOpenid) continue;
    counts.set(memberOpenid, 0);
    const normalized = normalizeAttackOpenid(memberOpenid);
    if (normalized && !openidToMember.has(normalized)) openidToMember.set(normalized, memberOpenid);
    const nickname = normalizeNickname(member?.nickname);
    // 닉네임이 겹치면 닉네임 매칭은 포기한다 - 엉뚱한 멤버에 타수를 붙이지 않는다.
    if (nickname) nicknameToMember.set(nickname, nicknameToMember.has(nickname) ? '' : memberOpenid);
  }

  for (const record of Array.isArray(records) ? records : []) {
    const normalized = normalizeAttackOpenid(record?.memberOpenid ?? record?.member_openid);
    const nickname = normalizeNickname(record?.nickname ?? record?.memberNickname ?? record?.member_nickname);
    const memberOpenid = openidToMember.get(normalized) || nicknameToMember.get(nickname) || '';
    if (!memberOpenid) continue;
    counts.set(memberOpenid, Math.min(maxCount, (counts.get(memberOpenid) || 0) + 1));
  }

  return counts;
}
